import { createRoot } from 'react-dom/client';
import App from './App';
import { HashRouter } from 'react-router-dom';

document.documentElement.lang = 'it';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <HashRouter>
        <App />
    </HashRouter>
);
